"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stakeBanx = void 0;
const common_1 = require("../../../../common");
const constants_1 = require("../../../constants");
const constants_2 = require("../../../constants");
const helpers_1 = require("../helpers");
const helpers_2 = require("./../../../helpers");
const mpl_token_metadata_1 = require("@metaplex-foundation/mpl-token-metadata");
const anchor_1 = require("@project-serum/anchor");
const token_1 = require("@project-serum/anchor/dist/cjs/utils/token");
const stakeBanx = ({ programId, connection, addComputeUnits, priorityFees, accounts, args, sendTxn }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const currentTimestamp = Math.floor(new Date().getTime() / 1000);
    const weeks = (0, helpers_1.adventureTimestampToWeeks)(currentTimestamp);
    const weekStart = (0, helpers_1.weeksToAdventureTimestamp)(weeks);
    const diffCurrentWeek = currentTimestamp - weekStart;
    if (diffCurrentWeek <= 86400) {
        args.weeksOfSubscriptions = args.weeksOfSubscriptions.find((week) => week === weeks)
            ? args.weeksOfSubscriptions
            : [weeks, ...args.weeksOfSubscriptions];
    }
    const program = (0, helpers_2.returnAnchorProgram)(programId, connection);
    const instructions = [];
    const banxStake = anchor_1.web3.Keypair.generate();
    const userTokenAccount = yield (0, common_1.findAssociatedTokenAddress)(accounts.userPubkey, accounts.tokenMint);
    const editionInfo = (0, helpers_2.getMetaplexEditionPda)(accounts.tokenMint);
    const nftMetadata = (0, helpers_2.getMetaplexMetadata)(accounts.tokenMint);
    const ownerTokenRecord = (0, helpers_2.findTokenRecordPda)(accounts.tokenMint, userTokenAccount);
    const meta = yield mpl_token_metadata_1.Metadata.fromAccountAddress(connection, nftMetadata);
    const ruleSet = (_a = meta.programmableConfig) === null || _a === void 0 ? void 0 : _a.ruleSet;
    const tokenRecordData = meta.tokenStandard === mpl_token_metadata_1.TokenStandard.ProgrammableNonFungible
        ? yield mpl_token_metadata_1.TokenRecord.fromAccountAddress(connection, ownerTokenRecord)
        : { delegate: null };
    const delegatePubkey = tokenRecordData.delegate;
    const [mutualBondTradeTxnVault] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_2.MUTUAL_BOND_TRADE_TXN_VAULT)], program.programId);
    const [banxUser] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_USER_PREFIX), accounts.userPubkey.toBuffer()], program.programId);
    const [banxPointsMap] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_POINTS_MAP_PREFIX), accounts.tokenMint.toBuffer()], program.programId);
    const modifyComputeUnits = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
        units: Math.round(800000 + Math.ceil(Math.random() * 10000)),
    });
    const requestHeap = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({ microLamports: priorityFees });
    instructions.push(requestHeap);
    if (!!addComputeUnits)
        instructions.push(modifyComputeUnits);
    const subscriptionParams = yield Promise.all(args.weeksOfSubscriptions.map((weeks) => __awaiter(void 0, void 0, void 0, function* () {
        const [adventure, adventureBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.ADVENTURE_PREFIX), constants_1.ENCODER.encode((0, helpers_1.weeksToAdventureTimestamp)(weeks).toString())], program.programId);
        const [adventureSubscription, subscriptionBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.ADVENTURE_SUBSCRIPTION_PREFIX), adventure.toBuffer(), banxStake.publicKey.toBuffer()], program.programId);
        return {
            weeks: new anchor_1.BN(weeks),
            subscriptionBump: subscriptionBump,
            adventureBump: adventureBump,
        };
    })));
    const subscribeRemainingAccounts = (yield Promise.all(args.weeksOfSubscriptions.map((weeks) => __awaiter(void 0, void 0, void 0, function* () {
        const [adventure] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.ADVENTURE_PREFIX), constants_1.ENCODER.encode((0, helpers_1.weeksToAdventureTimestamp)(weeks).toString())], program.programId);
        const [adventureSubscription] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.ADVENTURE_SUBSCRIPTION_PREFIX), adventure.toBuffer(), banxStake.publicKey.toBuffer()], program.programId);
        return [
            {
                pubkey: adventure,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: adventureSubscription,
                isSigner: false,
                isWritable: true,
            },
        ];
    })))).flat();
    const accountsIntoInstruction = {
        banxStake: banxStake.publicKey,
        banxUser: banxUser,
        banxPointsMap: banxPointsMap,
        user: accounts.userPubkey,
        hadoRegistry: accounts.hadoRegistry,
        whitelistEntry: accounts.whitelistEntry,
        mutualBondTradeTxnVault: mutualBondTradeTxnVault,
        tokenMint: accounts.tokenMint,
        userTokenAccount: userTokenAccount,
        ownerTokenRecord,
        nftMetadata,
        instructions: anchor_1.web3.SYSVAR_INSTRUCTIONS_PUBKEY,
        authorizationRulesProgram: constants_1.AUTHORIZATION_RULES_PROGRAM,
        tokenProgram: token_1.TOKEN_PROGRAM_ID,
        associatedTokenProgram: token_1.ASSOCIATED_PROGRAM_ID,
        systemProgram: anchor_1.web3.SystemProgram.programId,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        metadataProgram: constants_1.METADATA_PROGRAM_PUBKEY,
        editionInfo: editionInfo,
    };
    const remainingAccountsPnft = [
        {
            pubkey: ruleSet || constants_1.METADATA_PROGRAM_PUBKEY,
            isSigner: false,
            isWritable: false,
        },
        {
            pubkey: delegatePubkey || constants_1.METADATA_PROGRAM_PUBKEY,
            isSigner: false,
            isWritable: false,
        },
    ];
    const createAndSellBondRemainingAccounts = [...subscribeRemainingAccounts, ...remainingAccountsPnft];
    instructions.push(yield program.methods
        .stakeBanx(subscriptionParams)
        .accountsStrict(accountsIntoInstruction)
        .remainingAccounts(createAndSellBondRemainingAccounts)
        .instruction());
    const addressesForLookupTable = [
        ...Object.values(accountsIntoInstruction),
        ...Array.from(createAndSellBondRemainingAccounts, (x) => x.pubkey),
    ];
    console.log('accounts of stakeBanx: ', (0, helpers_2.anchorRawBNsAndPubkeysToNumsAndStrings)({ account: accountsIntoInstruction, publicKey: banxStake.publicKey }));
    console.log('remaining accounts of stakeBanx: ', createAndSellBondRemainingAccounts.map((remainingAccount) => remainingAccount.pubkey.toBase58()));
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    const signers = [banxStake];
    yield sendTxn(transaction, signers);
    return {
        banxStake: banxStake.publicKey,
        instructions,
        signers,
        addressesForLookupTable,
    };
});
exports.stakeBanx = stakeBanx;
